























import Enumerable from "linq";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { IDateFormatConfiguration } from "../../../../domain/configuration/IConfiguration";
import { ModelEditableMixin } from "../../../system/mixins";
import { StandardOption } from "../../../system/selectors/mixins";
import OptionDropDownSelector from "../../../system/selectors/OptionDropDownSelector.vue";

@Component({
  components: {
    selector: OptionDropDownSelector,
  },
})
export default class DateFormatEditor extends Mixins(ModelEditableMixin) {
  editingSource: string;

  @Prop({ default: false })
  isManualFormatSpecified: boolean;

  get formatConfiguration(): IDateFormatConfiguration {
    return this.findFormatConfiguration(this.editingSource);
  }

  findFormatConfiguration(format: string): IDateFormatConfiguration {
    const configuration = this.$store.getters.configuration.behavior.document.entities.date.formats as IDateFormatConfiguration[];
    return configuration
      ? Enumerable.from(configuration).firstOrDefault(c => (c.format === format) || ((c.format + c.dayOfWeekFormatPostfix) === format))
      : null;
  }

  get formats(): StandardOption<string>[] {
    const configuration = this.$store.getters.configuration.behavior.document.entities.date.formats as IDateFormatConfiguration[];
    return configuration
      ? Enumerable.from(configuration).where(c => this.isSelectableConfiguration(c)).select(c => new StandardOption<string>(c.label, c.format)).toArray()
      : [];
  }

  private isSelectableConfiguration(configuration: IDateFormatConfiguration): boolean {
    // 独自書式が指定されていないときはプルダウンに表示させない
    return !!this.isManualFormatSpecified || !this.isManualFormat(configuration.format) || this.isManualFormat(this.editingSource);
  }

  private isManualFormat(format: string): boolean {
    return !!format && /\$MANUAL\$/.test(format);
  }

  get isManualFormatSelected(): boolean {
    return this.isManualFormat(this.editingSource);
  }

  get format(): string {
    return this.formatConfiguration
      ? this.formatConfiguration.format
      : this.editingSource;
  }

  set format(value: string) {
    this.editingSource = this.toFormat(value, this.shouldShowDayOfWeek);
  }

  get shouldShowDayOfWeek(): boolean {
    return this.formatConfiguration
      && ((this.formatConfiguration.format + this.formatConfiguration.dayOfWeekFormatPostfix) === this.editingSource);
  }

  set shouldShowDayOfWeek(value: boolean) {
    this.editingSource = this.toFormat(this.format, value);
  }

  private toFormat(format: string, shouldShowDayOfWeek: boolean): string {
    const configuration = this.findFormatConfiguration(format);
    return shouldShowDayOfWeek && !this.isManualFormat(format)
      ? format + configuration.dayOfWeekFormatPostfix
      : format;
  }
}
